import React from "react";

const Clients_list = () => {
  return (
    <section className="clients-list">
      <div className="lft-bg">
        <img
          src={`/img/svg/happy-clients-lft-bg.svg`}
          alt="Left Background for Happy Clients Section"
        />
      </div>
      <div className="rgt-bg">
        <img
          src={`/img/svg/happy-clients-rgt-bg.svg`}
          alt="Right Background for Happy Clients Section"
        />
      </div>
      <h2
        className="section-main-heading wow fadeInUp duration animated"
        data-wow-duration="1000ms"
        data-wow-delay="600ms"
      >
        Our Happy Clients
      </h2>
      <ul className="page-wrap row">
        <li
          className="wow fadeInUp duration animated new_width"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/ALLSTARSIT.png`}
            alt="ALLSTARTIT - Virtuos Client"
          />
        </li>
      </ul>
      <ul className="page-wrap row">
        <li
          className="wow fadeInUp duration animated new_width"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/jade-global-logo.png`}
            alt="Jade Global - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInUp duration animated new_width"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/PickMe.png`}
            alt="PickMe - Virtuos Client"
          />
        </li>
      </ul>
      <ul className="page-wrap row">
        <li
          className="wow fadeInDown duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/svg/standard_chartered.svg`}
            alt="Standard Chartered - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInLeft duration animated new_width_kgisl"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/kgisl-logo.png`}
            alt="KGISL - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/svg/thomas-cook-2.svg`}
            alt="Thomas Cook - Virtuos Client"
          />
        </li>
      </ul>
      <ul className="page-wrap row">
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/clp-logo.png`}
            alt="CLP - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/svg/make-my-trip-logo.svg`}
            alt="Make my trip - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/myntra-logo.png`}
            alt="Myntra - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/indiafirst-logo.jpg`}
            alt="Indiafirst - Virtuos Client"
          />
        </li>
      </ul>
      <ul className="page-wrap row">
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/tvscs-logo.png`}
            alt="TVS Credit - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/svg/icons/fabindia-logo.svg`}
            alt="Fabindia - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/hike-logo.png`}
            alt="Hike - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/hdfc-life-logo.jpg`}
            alt="HDFC Life - Virtuos Client"
          />
        </li>
        <li
          className="wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="500ms"
        >
          <img
            src={`/img/svg/icons/securitas-logo.svg`}
            alt="Securitas - Virtuos Client"
          />
        </li>
      </ul>
    </section>
  );
};

export default Clients_list;
